/**
 * @generated SignedSource<<020aa29fa1739ada10d9ff8b75029e2e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type accountDropzone_PollQuery$variables = {
  id: string;
};
export type accountDropzone_PollQuery$data = {
  readonly multiUpload: {
    readonly errorMessage: string | null | undefined;
    readonly notice: string | null | undefined;
    readonly phase: string | null | undefined;
    readonly state: string;
  } | null | undefined;
};
export type accountDropzone_PollQuery = {
  response: accountDropzone_PollQuery$data;
  variables: accountDropzone_PollQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phase",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorMessage",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notice",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "accountDropzone_PollQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MultiUpload",
        "kind": "LinkedField",
        "name": "multiUpload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "accountDropzone_PollQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MultiUpload",
        "kind": "LinkedField",
        "name": "multiUpload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7468d1efb50d48e508ce9b859c35ebb0",
    "id": null,
    "metadata": {},
    "name": "accountDropzone_PollQuery",
    "operationKind": "query",
    "text": "query accountDropzone_PollQuery(\n  $id: ID!\n) {\n  multiUpload(id: $id) {\n    phase\n    state\n    errorMessage\n    notice\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2221579e68a0bcf86099fe7228fc3bb7";

export default node;
